import BedbankCancellationPolicy from 'components/OfferPage/Bedbank/BedbankCancellationPolicy'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'
import useBedbankOfferSearchPricing from 'hooks/useBedbankOfferSearchPricing'
import { buildBedbankCancellationPolicy } from 'lib/search/hotels'
import { useMemo } from 'react'
import CellContent from './CellContent'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters: App.OfferListFilters
}

function BedbankHotelSearchCancellationPolicyCell({ offer, filters }: Props) {
  const offerMetaData = useOfferMetaData(offer.id, filters)

  const {
    shownRate,
  } = useBedbankOfferSearchPricing(offer, filters)

  const cancellationPolicy = useMemo(() => {
    return buildBedbankCancellationPolicy(
      offerMetaData?.cancellationPolicyInfo,
      filters,
      offer.property.timezone,
    )
  }, [offerMetaData?.cancellationPolicyInfo, filters, offer.property.timezone])

  if (!(offer.productType === 'limited_time_special' && (shownRate || cancellationPolicy))) {
    return null
  }

  return <CellContent>
    <BedbankCancellationPolicy
      rate={shownRate ?? cancellationPolicy}
      showNonCancellation
    />
  </CellContent>
}

export default BedbankHotelSearchCancellationPolicyCell
